var _path;
import * as React from "react";
function SvgChevronBoldRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.194 21.244L14.952 35.485c-.686.687-1.8.687-2.487 0l-1.66-1.661a1.759 1.759 0 01-.004-2.484L22.088 20 10.802 8.66a1.758 1.758 0 01.003-2.484l1.661-1.661a1.759 1.759 0 012.487 0l14.241 14.242c.687.686.687 1.8 0 2.487z"
  })));
}
export default SvgChevronBoldRight;